function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M49.9,29.5h0V17.4L36.2,29.3h-.3V17.4L22.2,29.3h0V4.4C22.2,2.3,17.5.2,11.3.2S0,2.2,0,4.4V50H50ZM11.3,6.4c-4.5,0-8.1-1.1-8.1-2.3s3.6-2.3,8.1-2.3,8.1,1,8.1,2.3C19.3,5.3,15.7,6.4,11.3,6.4ZM34.9,41.9H29.4V36.4h5.5Zm-9.7,0H19.7V36.4h5.5Zm14,0V36.4h5.5v5.5Z",
  transform: "translate(0 -0.101)",
  fill: "#1590cf"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  width: 11.071,
  height: 45.91,
  transform: "translate(0 3.99)",
  fill: "#046eab"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M22.043,4.09c0,2.194-4.987,3.99-11.071,3.99S0,6.284,0,4.09,4.987.1,11.071.1,22.043,1.8,22.043,4.09",
  transform: "translate(0 -0.1)",
  fill: "#fff"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M19.855,3.793c0,1.5-3.89,2.593-8.777,2.593S2.3,5.289,2.3,3.793,6.19,1.2,11.077,1.2s8.777,1.2,8.777,2.593",
  transform: "translate(-0.006 -0.103)",
  fill: "#046eab"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M17.959,5.389c1.2-.4,1.8-1,1.8-1.6,0-1.5-3.89-2.593-8.777-2.593S2.2,2.4,2.2,3.793c.1.6.8,1.2,1.9,1.6a21.175,21.175,0,0,1,6.982-1,20.952,20.952,0,0,1,6.882,1",
  transform: "translate(-0.006 -0.103)",
  fill: "#1590cf"
});

var SvgDataFactories = function SvgDataFactories(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 49.9,
    viewBox: "0 0 50 49.9",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDataFactories, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/data_factories.8c551d05.svg";
export { ForwardRef as ReactComponent };